import { Component } from '@angular/core';
import {  App } from 'ionic-angular';
import { AppState } from '../../../../../app/app.global';
import { ProblemDetail } from '../problemdetail/problemdetail';

@Component({
  templateUrl: 'problemlist.html'
})

export class ProblemList{
	questions:any[];
	constructor(public global: AppState,public appCtrl: App) {
		this.questions = [
         {"id":"103443333","title":"天气为毛如此的冷?","content":"一股寒流从希伯来而来"},
         {"id":"103443335","title":"为什么打雷会下雨?","content":"打雷就要下点雨"},
         {"id":"103443338","title":"为何你是如此的疯狂?","content":"因为你有病"},
         {"id":"103443336","title":"为什么我没发财?","content":"因为你懒,的点点滴滴"},
         {"id":"103443310","title":"什么时候天气暖和?","content":"暖和的时候自然就暖和了"},
       ];
	}
	openQuestionDetail(item){
		this.appCtrl.getRootNav().push(ProblemDetail,item);
	}
	loadMore(refresher){
		setTimeout(() => {
      console.log("这里加载新数据");
      refresher.complete();
    }, 1000);
	}
}


// WEBPACK FOOTER //
// ./src/pages/application/dailyoffice/helpcenter/problemlist/problemlist.ts